import { render, staticRenderFns } from "./solicitacoes.vue?vue&type=template&id=3d4c7a80&scoped=true&lang=pug&"
import script from "./solicitacoes.vue?vue&type=script&lang=js&"
export * from "./solicitacoes.vue?vue&type=script&lang=js&"
import style0 from "./solicitacoes.vue?vue&type=style&index=0&id=3d4c7a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4c7a80",
  null
  
)

export default component.exports